if (window._subiz_init_2094850928430) throw new Error('subiz have already initialized')
window._subiz_init_2094850928430 = true
const VERSION = require('./detect_version.js')()
if (!VERSION) throw new Error('subiz cannot detect version')

import store from '@sb/store'
const sb = require('@sb/util')

import controller from './views/controller.js'

// JSAPI
const apiV4 = {}
// INCOMPATIBLE with v2: getVisitorId, getInfo
// v2 backward compatible
apiV4.setInfo = info => {
	if (!info) return
	var attributes = []
	if (info.name) attributes.push({ key: 'fullname', text: info.name })
	if (info.email) attributes.push({ key: 'emails', text: info.email })
	if (info.phone) attributes.push({ key: 'phones', text: info.phone })
	if (attributes.length === 0) return
	apiV4.updateUserAttributes(attributes)
}

apiV4.setAccount = id => store.init(id)
apiV4._setAccount = apiV4.setAccount // deprecated
apiV4.setPosition = position => {}
apiV4.updateUserAttributes = async attributes => {
	await store.setUser({ attributes })
	return sb.cloneDeep(store.user.attributes)
}

apiV4.getUserAttributes = async () => {
	await store.readyGate.entry()
	return sb.cloneDeep(sb.get(store.user, 'attributes', []))
}

apiV4.expandWidget = (view, convo) => controller.showWidget(view, convo)
apiV4.shrinkWidget = () => controller.hideWidget()
apiV4.deleteUser = apiV4.forgetMe // deprecated
apiV4.showWidget = (view, convo) => controller.showWidget(view, convo)
apiV4.hideWidget = () => controller.hideWidget()
apiV4.showChatButton = () => controller.showChatButton()
apiV4.showButton = apiV4.showChatButton // deprecated
apiV4.hideChatButton = () => controller.hideChatButton()
apiV4.showOfflineForm = () => controller.showOfflineForm()
apiV4.showPrechatForm = () => controller.showPrechatForm()
apiV4.showConvo = id => controller.showConvo(id)

const noop = () => {}
apiV4.askPushNotification = noop
apiV4.askInfo = noop
apiV4.askFeedback = noop
apiV4.showProduct = noop
apiV4.version = () => '4.238'
apiV4.preview = () => store.preview()
apiV4.setSetting = setting => store.setSetting(setting)

apiV4.sendWs = async event => {
	await store.readyGate.entry()
	store.onWs(event)
}

apiV4.setCss = css => store.setCss(css)

apiV4.__setConvos = async convos => {
	await store.readyGate.entry()
	store._setConvos(convos)
}

apiV4.setLanguage = async (code, data) => {
	if (!sb.isValidLanguageCode(code)) return
	await store.readyGate.entry()
	await store.setLanguage(code, '', data)
}

function callV2 (args) {
	args = sb.map(args, ag => ag)

	if (!Array.isArray(args)) return
	if (args.length < 1) return
	var method = args.shift()

	if (typeof apiV4[method] !== 'function') return
	return apiV4[method](...args)
}

async function init () {
	// backward compatible api
	if (VERSION === '1') apiV4._setAccount(window.subiz_account_id)
	if (VERSION === '2' || VERSION == '4.1') {
		let queue = window._sbzq || []
		window._sbzq = { push: callV2 }
		queue.forEach(i => callV2(i))
	}

	if (VERSION === '4.2') {
		let queue = window.subiz.q || []
		window.subiz = function () {
			// do not convert to arrow function, arguments will be null
			return callV2(arguments)
		}
		queue.forEach(i => callV2(i))
	}

	await store.readyGate.entry()
	store.track()

	controller.mount()
	// require('./fcm.js').default()

	require('./campaign.js').default()
}
init()
